import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: 'AIzaSyBlSsNVjzdhVU_W470-6ovbfN4S-eUgkH4',
  authDomain: 'btms-mobile-app.firebaseapp.com',
  projectId: 'btms-mobile-app',
  storageBucket: 'btms-mobile-app.appspot.com',
  messagingSenderId: '52927747403',
  appId: '1:52927747403:web:8e756b0fdc8fee8fb344ce',
  measurementId: 'G-R892BLDF6E',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const messaging = getMessaging(app)

// Request Notification Permission
export const requestPushNotifications = async () => {
  try {
    const permission = await Notification.requestPermission()

    if (permission !== 'granted') {
      console.warn(
        'User blocked notifications. Please enable them in browser settings.',
      )
      return
    }

    const token = await getToken(messaging, {
      vapidKey:
        'BF3TJAVPYO_OwSNjBK6OAM9WE_vC0CiUcEeg6fw8rx1OMcj28pw5Vg_KsAW6N5UtTukfamCuuzu_qfA3jeYBCwM',
    })

    if (token) {
      console.log('FCM Token:', token)
      return token
    } else {
      console.log('No registration token available.')
    }
  } catch (error) {
    console.error('Error getting FCM token:', error)
  }
}

// Listener for messages
export const onMessageListener = (callback) => {
  onMessage(messaging, (payload) => {
    console.log('Notification received:', payload)
    if (callback) callback(payload)
  })
}
